/* <product-recommendations>: fetch this section when it nears the viewport.
   Default source is products sharing a tag (via search); falls back to Shopify recommendations. */
(() => {
  if (customElements.get('product-recommendations')) return;
  customElements.define('product-recommendations', class extends HTMLElement {
    connectedCallback() {
      if (this.querySelector('[data-ct-track] .ct__item')) return; // already rendered (theme editor)
      const getFresh = async url => {
        const html = await (await fetch(url)).text();
        const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('product-recommendations');
        if (!fresh) return null;
        const ex = this.dataset.exclude;
        fresh.querySelectorAll('.ct__item').forEach(i => { if (ex && i.dataset.productId === ex) i.remove(); });
        return fresh.querySelector('.ct__item') ? fresh : null;
      };
      const load = async () => {
        try {
          let fresh = await getFresh(this.dataset.url);
          if (!fresh && this.dataset.fallbackUrl) fresh = await getFresh(this.dataset.fallbackUrl);
          if (fresh) this.innerHTML = fresh.innerHTML;
          else this.closest('.shopify-section')?.setAttribute('hidden', '');
        } catch (e) { /* leave empty */ }
      };
      if (!('IntersectionObserver' in window)) { load(); return; }
      const io = new IntersectionObserver(es => { if (es.some(e => e.isIntersecting)) { io.disconnect(); load(); } }, { rootMargin: '400px' });
      io.observe(this);
    }
  });
})();
